import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import { ColorV2 } from "config/colors";
import { ContinueButton, StyledForm, StyledTitle } from "./confirmation.styled";

const CONFIRMATION_BUTTON_STYLES: Partial<BaseButtonStyle> = {
  backgroundColor: ColorV2.PositiveGreen,
  hoverBackgroundColor: ColorV2.SimflexityGreen,
  activeBackgroundColor: ColorV2.SimflexityGreen,
  disabledBackgroundColor: ColorV2.PositiveGreenLight,
  disabledTextColor: ColorV2.White,
  disabledBorderColor: "transparent",
};

type Props = {
  handleLogin: () => Promise<void>;
};

export const Confirmation: React.FC<Props> = ({ handleLogin }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <StyledForm
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <StyledTitle>{t("RegisterCompany.CompanyAdded")}</StyledTitle>
      <ContinueButton
        label={t("RegisterCompany.Continue")}
        disabled={isSubmitting}
        isLoading={isSubmitting}
        onClick={async () => {
          if (isSubmitting) {
            return;
          }

          setIsSubmitting(true);
          try {
            await handleLogin();
          } finally {
            setIsSubmitting(false);
          }
        }}
        styleOverrides={CONFIRMATION_BUTTON_STYLES}
      />
    </StyledForm>
  );
};
